// extracted by mini-css-extract-plugin
export default {"filterBox":"lesson-reviews_filterBox__lvlOJ","reactionsContainer":"lesson-reviews_reactionsContainer__NJJdq"};